
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetoajantaelloracab() {



  const cardData =
  {
    keyword: '  Pune to Ajanta Ellora Cabs',
    heading: 'Vaishnavi Travels: Pune to Ajanta Ellora Cabs',
    headingDescription: 'Vaishnavi Travels provides dependable and affordable Pune to Ajanta Ellora Cabs, ideal for family trips, school excursions, corporate outings, and pilgrimages. Our cabs are well-maintained with spacious seating, strong air-conditioning, and ample luggage space, ensuring a smooth and comfortable journey on the Pune–Ajanta Ellora route. With professional chauffeurs, punctual pickups, and flexible booking options, we make long-distance travel convenient and stress-free. Whether it’s exploring the historic Ajanta caves, visiting Ellora temples, or combining a cultural and leisure tour, Vaishnavi Travels guarantees safe, reliable, and comfortable cab services from Pune to Ajanta Ellora.',

    top: 'Top Places to Visit in Ajanta Ellora with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "The Ajanta Caves, a UNESCO World Heritage Site, date back to the 2nd century BCE and are world-renowned for their Buddhist paintings and sculptures. Spread across 30 caves, they depict the life of Lord Buddha through murals and frescoes. The caves reflect extraordinary artistry and storytelling. Surrounded by lush hills, the horseshoe-shaped gorge adds natural beauty. Monsoon enhances the scenic charm of the caves. Ajanta is India’s timeless treasure of art, faith, and heritage."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves, another UNESCO World Heritage Site, consist of 34 caves representing Hindu, Buddhist, and Jain traditions. The site showcases religious harmony through rock-cut architecture spanning centuries. The caves feature monasteries, temples, and intricately carved sculptures. Tourists admire its scale and detailing, which highlight India’s ancient craftsmanship. The natural setting adds to the charm. Ellora is Maharashtra’s proud monument of unity in diversity."
  },
  {
    "title": "Kailasa Temple (Ellora)",
    "description": "The Kailasa Temple at Ellora is one of the world’s largest monolithic rock-cut temples, dedicated to Lord Shiva. Carved out of a single basalt rock, it symbolizes Mount Kailash. Its intricate sculptures, grand courtyards, and multi-storey structures amaze historians and architects. Visitors marvel at the sheer scale of workmanship achieved in the 8th century. It remains a living temple of worship. Kailasa Temple is Ellora’s crowning masterpiece of devotion and art."
  },
  {
    "title": "Ajanta Cave 1",
    "description": "Ajanta’s Cave 1 is one of the finest examples of Buddhist art, famous for its murals depicting Bodhisattva Padmapani and Vajrapani. The paintings reflect compassion, devotion, and spiritual wisdom. Intricate ceiling decorations and sculptures add to its beauty. Art lovers admire the blend of storytelling and aesthetics. It offers deep insight into Buddhist philosophy. Cave 1 is Ajanta’s gem of painting and spirituality."
  },
  {
    "title": "Ajanta Cave 26",
    "description": "Cave 26 of Ajanta is a large Chaitya (prayer hall) featuring an iconic reclining Buddha sculpture representing Mahaparinirvana. Its pillars are decorated with carvings narrating Jataka tales. The hall’s grandeur and emotional depth leave visitors in awe. It is a favorite among pilgrims and historians alike. The cave represents both serenity and artistic brilliance. Ajanta Cave 26 is a profound spiritual treasure."
  },
  {
    "title": "Ellora Jain Caves",
    "description": "The Jain caves at Ellora, located at the northern end of the complex, are dedicated to Tirthankaras. Carved in the 9th–10th centuries, they display intricate detailing, pillars, and shrines. Cave 32 (Indra Sabha) is the most popular, featuring life-size sculptures and a double-storey structure. These caves highlight simplicity and devotion alongside artistic mastery. They attract Jain pilgrims and tourists alike. Ellora’s Jain caves are sacred gems of spirituality and art."
  },
  {
    "title": "Ellora Buddhist Caves",
    "description": "The Buddhist caves at Ellora, dating from the 5th to 7th centuries, were monasteries for monks. Cave 10, known as the Vishvakarma or Carpenter’s Cave, has a striking stupa and vaulted ceiling. Other caves feature meditation halls, prayer chambers, and sculptures of Buddha in various forms. The calm environment makes them ideal for reflection. They represent Buddhist devotion and discipline. Ellora’s Buddhist caves are serene sanctuaries of meditation."
  },
  {
    "title": "Grishneshwar Temple",
    "description": "Located near Ellora, Grishneshwar Temple is one of the 12 Jyotirlingas dedicated to Lord Shiva. Rebuilt in the 18th century by Ahilyabai Holkar, it features Hemadpanthi-style architecture. Devotees believe worship here brings divine blessings. The temple’s red stone carvings and tall shikhara are architecturally striking. Pilgrims often combine it with Ellora sightseeing. Grishneshwar is Ajanta–Ellora’s sacred spiritual highlight."
  },
  {
    "title": "Ajanta Viewpoint",
    "description": "The Ajanta Viewpoint, located across the gorge, offers a panoramic view of the entire horseshoe-shaped series of caves. Tourists admire the scale and beauty of the site from here before entering the caves. The viewpoint is especially scenic during monsoon, with waterfalls cascading nearby. Photographers capture breathtaking landscapes from this spot. It adds a natural dimension to the Ajanta experience. The viewpoint is Ajanta’s scenic introduction to history and art."
  },
  {
    "title": "Daulatabad Fort (Nearby)",
    "description": "Daulatabad Fort, located near Ellora, is a hilltop fortress known for its strategic defenses and rich history. Built in the 12th century, it was briefly the capital of Muhammad bin Tughlaq. The fort’s moats, secret passages, and Chand Minar tower fascinate visitors. The climb rewards trekkers with panoramic views. It combines adventure with heritage exploration. Daulatabad Fort is Ajanta–Ellora’s nearby historic marvel."
  }
],


    "services": [
    {
      "name": "Pune to Ajanta Ellora Taxi Booking",
      "description": "Book reliable and comfortable taxi services from Pune to Ajanta Ellora caves, perfect for solo travelers, families, and groups. Our service provides flexible booking options including one-way and round trips, ensuring a hassle-free journey to the famous heritage sites. Vehicles are well-maintained, driven by experienced professionals dedicated to safety, punctuality, and excellent customer service throughout your cultural excursion."
    },
    {
      "name": "AC Cab for Cave Tour",
      "description": "Travel in cool comfort to the Ajanta and Ellora caves with our air-conditioned cab services. These vehicles offer a refreshing and pleasant environment, ideal for long drives across rugged terrain. Perfect for tourists and history enthusiasts who want a comfortable ride while exploring these UNESCO World Heritage Sites."
    },
    {
      "name": "Round Trip Cab Ajanta Ellora",
      "description": "Convenient round trip cab services from Pune to Ajanta Ellora that allow you to explore both cave complexes at your own pace. Enjoy flexible pick-up and drop-off timings, stops at local attractions and eateries, and comfortable travel with trusted drivers familiar with the heritage route."
    },
    {
      "name": "One Way Taxi Ajanta Ellora",
      "description": "Affordable one-way taxi options for travelers heading from Pune to Ajanta Ellora or vice versa. Ideal for those with onward travel plans or specific drop-off locations, our one-way service guarantees transparent pricing, courteous drivers, and safe journeys customized to your itinerary."
    },
    {
      "name": "Budget Cab Pune to Ajanta",
      "description": "Cost-effective and reliable budget taxi services from Pune to Ajanta Ellora, suited for solo travelers or groups looking to save on transportation without compromising on safety or comfort. Our fleet includes well-maintained vehicles offering basic amenities at competitive prices for your heritage tour."
    },
    {
      "name": "SUV Cab Cave Tour",
      "description": "Premium SUV cab rentals for your Ajanta Ellora cave tour, offering extra space, rugged comfort, and superior road handling. Perfect for families, groups, or travelers seeking enhanced comfort and style on this cultural journey through Maharashtra’s historic landmarks."
    },
    {
      "name": "Family Trip Taxi Ajanta",
      "description": "Tailored taxi services for family trips from Pune to Ajanta Ellora, ensuring safety, convenience, and a comfortable ride. Spacious vehicles and courteous drivers make it easy for families to enjoy their cultural and heritage excursions without transport worries."
    },
    {
      "name": "Corporate Tour Cab",
      "description": "Professional corporate cab services designed for business travelers and corporate groups visiting Ajanta Ellora from Pune. Reliable, punctual, and discreet transportation with options for AC, SUVs, and luxury vehicles suited for corporate retreats, team outings, or client visits."
    },
    {
      "name": "Online Ajanta Booking Cab",
      "description": "Secure and easy online booking platform for Ajanta Ellora cabs from Pune. Choose your vehicle, schedule your trip, and receive instant confirmation with 24/7 customer support, ensuring a smooth and stress-free booking experience for your heritage tour."
    },
    {
      "name": "Heritage Tour Taxi Pune",
      "description": "Specialized heritage tour taxi services offering knowledgeable drivers who can guide you through Ajanta Ellora’s rich history while providing comfortable and safe transportation. This service enhances your cultural trip with personalized stops and insights into the UNESCO World Heritage Sites."
    },
    {
      "name": "Day Trip Taxi Ajanta Ellora",
      "description": "Ideal day trip taxi services from Pune to Ajanta Ellora, allowing you to visit the caves and return the same day comfortably. Perfect for travelers with limited time who want to maximize their experience of these historic sites without overnight stays."
    },
    {
      "name": "Cab with Driver Pune Ajanta",
      "description": "Hire a cab with an experienced driver for your Pune to Ajanta Ellora trip, letting you relax and enjoy the scenic journey without the stress of driving. Drivers are knowledgeable, courteous, and committed to providing a smooth and memorable travel experience."
    },
    {
      "name": "Group Tour Cab",
      "description": "Spacious and comfortable group tour cabs from Pune to Ajanta Ellora, ideal for larger parties, school trips, or social groups. These vehicles provide ample seating, luggage space, and flexible itineraries to ensure an enjoyable and hassle-free heritage tour for everyone."
    }
  ],
  "tableData": [
    ["Pune to Ajanta Ellora Taxi Booking", "AC Cab for Cave Tour"],
    ["Round Trip Cab Ajanta Ellora", "One Way Taxi Ajanta Ellora"],
    ["Budget Cab Pune to Ajanta", "SUV Cab Cave Tour"],
    ["Family Trip Taxi Ajanta", "Corporate Tour Cab"],
    ["Online Ajanta Booking Cab", "Heritage Tour Taxi Pune"],
    ["Day Trip Taxi Ajanta Ellora", "Cab with Driver Pune Ajanta"],
    ["Group Tour Cab"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Ajanta Ellora Cabs",
    "WhyChoosedescription": "Vaishnavi Travels offers reliable and comfortable cab services from Pune to Ajanta Ellora, ideal for heritage tours and group excursions."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from Swift Dzire, Ertiga, Innova, Urbania, and Tempo Traveller based on your group size and comfort preferences."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our vehicles are regularly serviced and thoroughly cleaned to ensure safety and hygiene throughout your journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our professional drivers know the best routes between Pune and Ajanta Ellora to ensure a smooth and timely travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer all-inclusive pricing covering fuel, tolls, parking, and driver allowance with no hidden charges."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
    "WhyChoosedescription": "Enjoy convenient door-to-door service from your home, hotel, or office in Pune and drop-off at your preferred destination near Ajanta Ellora."
  },
  {
    "WhyChooseheading": "Ideal for Heritage Tours and Group Trips",
    "WhyChoosedescription": "Perfect for families, friends, and tour groups looking to explore the historic Ajanta and Ellora caves comfortably."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist you with bookings, itinerary planning, and travel inquiries."
  }
]






















  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels provide cab services from Pune to Ajanta and Ellora?',
      answer: 'Yes, Vaishnavi Travels offers comfortable and reliable cab services from Pune to Ajanta and Ellora, ideal for heritage tours, family trips, and sightseeing.',
    },
    {
      question: 'What types of cabs are available for the Pune to Ajanta and Ellora route?',
      answer: 'We offer a variety of vehicles including Swift Dzire, Ertiga, Innova, and Tempo Travellers to accommodate different group sizes and travel preferences.',
    },
    {
      question: 'What is the typical fare for a cab from Pune to Ajanta and Ellora?',
      answer: 'Fares generally start from ₹3,500 for a one-way trip in a sedan like Swift Dzire. Rates vary based on vehicle type, trip duration, and return options.',
    },
    {
      question: 'Can I book a round trip cab from Pune to Ajanta and Ellora?',
      answer: 'Yes, we offer flexible round trip packages for same-day or multi-day stays with transparent pricing and customizable itineraries.',
    },
    {
      question: 'How far in advance should I book a Pune to Ajanta and Ellora cab?',
      answer: 'It is recommended to book at least 1-2 days in advance, especially during weekends and holiday seasons to ensure vehicle availability.',
    },
    {
      question: 'Is doorstep pickup and drop-off available for Pune to Ajanta and Ellora cabs?',
      answer: 'Yes, Vaishnavi Travels provides convenient doorstep pickup and drop-off services anywhere in Pune and nearby areas.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Rahul Deshmukh",
    position: "Travel Blogger",
    feedback:
      "Vaishnavi Travels made our Pune to Ajanta and Ellora trip hassle-free and enjoyable. The cab was comfortable, and the driver was friendly and knowledgeable.",
    rating: 5,
  },
  {
    name: "Ms. Anjali Patil",
    position: "Tourist",
    feedback:
      "Great experience with Vaishnavi Travels for Ajanta and Ellora cab service. Timely pickup, clean vehicle, and smooth ride through the hills. Highly recommended!",
    rating: 5,
    style: "style-2",
  }
];













































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const puneToAjantaElloraCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Ajanta Ellora Cabs",
  "description": "Book AC and budget taxis from Pune to Ajanta Ellora caves for one-way or round trips. SUV, family, corporate cabs available with driver for heritage and day tours.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Vaishnavi Travels",
    "telephone": "+91-9765685295",
    "url": "https://vaishnavitravel.com/pune-to-ajanta-ellora-cabs"
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "Place",
      "name": "Ajanta Ellora Caves"
    }
  ],
  "serviceType": [
    "Pune to Ajanta Ellora Taxi Booking",
    "AC Cab for Cave Tour",
    "Round Trip Cab Ajanta Ellora",
    "One Way Taxi Ajanta Ellora",
    "Budget Cab Pune to Ajanta",
    "SUV Cab Cave Tour",
    "Family Trip Taxi Ajanta",
    "Corporate Tour Cab",
    "Online Ajanta Booking Cab",
    "Heritage Tour Taxi Pune",
    "Day Trip Taxi Ajanta Ellora",
    "Cab with Driver Pune Ajanta",
    "Group Tour Cab"
  ],
  "availability": "https://schema.org/InStock"
};





  return (
    <div>

<Helmet>
  <title>Pune to Ajanta Ellora Cabs | AC & Budget Taxi Service</title>
  <meta
    name="description"
    content="Book AC and budget taxis from Pune to Ajanta Ellora caves for one-way or round trips. SUV, family, corporate cabs available with driver for heritage and day tours."
  />
  <meta
    name="keywords"
    content="Pune to Ajanta Ellora Taxi Booking, AC Cab for Cave Tour, Round Trip Cab Ajanta Ellora, One Way Taxi Ajanta Ellora, Budget Cab Pune to Ajanta, SUV Cab Cave Tour, Family Trip Taxi Ajanta, Corporate Tour Cab, Online Ajanta Booking Cab, Heritage Tour Taxi Pune, Day Trip Taxi Ajanta Ellora, Cab with Driver Pune Ajanta, Group Tour Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToAjantaElloraCabSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/68.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoajantaelloracab;